import { useEmployees } from 'hooks/useEmployees';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Grid,
  IconButton,
  Stack,
  styled,
  Tooltip,
  Typography,
} from '@mui/material';
import { useRef } from 'react';

type Props = {};

const Input = styled('input')({
  display: 'none',
});

export const EmployeeDocument: React.FC<Props> = () => {
  const { fileRegisterEmployee, setFileRegisterEmployee, setListErrors } =
    useEmployees();

  const ref = useRef(null);

  const handleUploadFile = (event: any) => {
    setFileRegisterEmployee(event.target.files[0]);
    setListErrors([]);
  };

  const handleDelete = () => {
    if (!ref.current) {
      return;
    }
    //@ts-ignore
    ref.current.value = '';
    setFileRegisterEmployee(null);
  };

  return (
    <>
      <Grid item container justifyContent="center" direction="row">
        <Grid item xs={12} md="auto">
          <Typography fontWeight={500} textAlign="center" mb={2}>
            Arquivos de Colaboradores
          </Typography>

          {/* TODO: Check types documents */}
          <Grid item xs={12} md="auto" mb={2}>
            <label htmlFor="document">
              <Input
                ref={ref}
                id="document"
                name="document"
                accept=".xlsx,.xls,.csv,.ods"
                type="file"
                value={''}
                onChange={handleUploadFile}
              />

              {/* TODO: Add foward ref to button component */}
              <Tooltip title="Anexar Documento">
                <Button
                  variant="outlined"
                  component="span"
                  size="large"
                  fullWidth
                  endIcon={<CloudUploadIcon />}
                >
                  Anexar arquivo padrão
                </Button>
              </Tooltip>
            </label>
          </Grid>
        </Grid>
      </Grid>
      {fileRegisterEmployee && (
        <Grid item container xs={12} md={12} justifyContent="center" mb={2}>
          <Stack
            direction="row"
            bgcolor="#eff1f3"
            borderRadius={1}
            px={2}
            py="4px"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography noWrap>{fileRegisterEmployee.name}</Typography>

            <Tooltip title="Deletar">
              <IconButton
                aria-label="Deletar"
                onClick={handleDelete}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Grid>
      )}
    </>
  );
};

